import React from "react"
import styled, { css } from "styled-components";
import { components } from "react-select";

const Chevron = styled.img`
  width: 12px;

  ${({ expanded }) =>
    expanded &&
    css`
      transform: rotate(180deg);
    `}
`;

export const DropdownIndicator = props => {
  return props.selectProps.isDisabled
    ? null
    : (
      <components.DropdownIndicator {...props}>
        <Chevron
          expanded={props.selectProps.menuIsOpen}
          src={require("assets/images/chevron-down-icon.svg")}
        />
      </components.DropdownIndicator>
    );
};
